import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { format, parseISO } from 'date-fns';

@Pipe({
  name: 'lcmsswissDate'
})
export class SwissDatePipe implements PipeTransform {

  transform(value: string, type: 'full' | 'default' = 'default'): string {

    if(!value) {
      return '';
    }

    // parse string to Date
    const date = parseISO(value);

    switch(type) {
      case 'full':
        return format(date, 'dd.MM.yyyy HH:mm');
      default:
        return format(date, 'dd.MM.yyyy');
    }

  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [SwissDatePipe],
  exports: [SwissDatePipe],
})
export class SwissDatePipeModule {}
